import React, { useRef } from "react";

import Box, { type BoxProps } from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import TableHeader from "src/components/TableHeader";

interface DetailsProps extends BoxProps {
  open: boolean;
  onClose?: () => void;
}

function Details({ open, ...rest }: DetailsProps) {
  const ref = useRef(rest);
  if (open) ref.current = rest;

  const { title, onClose, children, ...props } = ref.current;

  return (
    <Collapse in={open} mountOnEnter unmountOnExit timeout={800}>
      <Box
        display="flex"
        flexDirection="column"
        minHeight={730}
        height="auto"
        p={2.5}
        pt={0}
        {...props}
      >
        {title ? (
          <TableHeader title={title}>
            {onClose ? (
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </TableHeader>
        ) : null}
        {children}
      </Box>
    </Collapse>
  );
}

export default Details;
